"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Used by Avatar component to transform given full name into initials
 * NOTE: Check __tests__/utils/transformName.test.js for possible cases
 *
 * This function receives a single string or an array of strings.
 */
var transformName = function transformName(name) {
  if (!name) return '';
  if (Array.isArray(name)) name = name.join(' ');
  name = name.trim();
  if (name.length === 0) return '';
  var splitted = name.split(' ').map(function (str) {
    return str.trim();
  }).filter(function (str) {
    return str.length > 0;
  });

  if (splitted.length === 1) {
    return splitted[0].slice(0, 2).toUpperCase();
  }

  return (splitted[0].slice(0, 1) + splitted[splitted.length - 1].slice(0, 1)).toUpperCase();
};

var _default = transformName;
exports.default = _default;